import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CreatingFilesIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 226 190">
    <svg fill="none">
      <g clipPath="url(#prefix__clip0_1739:6153)">
        <path
          d="M113.792 188.18c47.835 0 86.713-38.877 86.713-86.713 0-47.835-38.878-86.713-86.713-86.713-47.835.18-86.713 38.878-86.713 86.893 0 47.835 38.878 86.533 86.713 86.533z"
          fill="#F1F3F9"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M170.764 87.492v64.318c0 3.942-3.225 7.167-7.166 7.167H61.657c-3.942 0-7.167-3.225-7.167-7.167V87.492c0-3.941 3.404-7.166 7.167-7.166h101.941c3.046 0 5.554 1.792 6.808 4.479.179.716.358 1.612.358 2.687z"
          fill="#F1F3F9"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M221.107 79.97c2.867-2.688 3.046-7.167.537-10.034-2.687-2.866-7.166-3.045-10.032-.537-2.867 2.687-3.046 7.166-.538 10.033 2.687 3.045 7.166 3.225 10.033.537zM221.646 48.613c1.254-1.075 1.254-3.045.179-4.12-1.075-1.254-3.046-1.254-4.121-.18-1.075 1.075-1.254 3.046-.179 4.121 1.075 1.254 2.866 1.254 4.121.18zM146.757 5.258c.895-.717.895-2.15.179-2.867-.717-.895-1.971-.895-2.867-.179-.896.717-.896 1.971-.179 2.867.717.896 1.971.896 2.867.179z"
          fill="#F1F3F9"
        />
        <path
          d="M207.67 46.285l-25.44 45.148c-.896 1.433-2.867 1.97-4.3 1.075l-43.357-25.261c-1.433-.896-1.97-2.867-1.075-4.3l33.503-57.51c.896-1.433 2.867-1.97 4.3-1.075l31.532 18.453 4.837 23.47z"
          fill="#fff"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M202.476 22.64l-7.167 12.182c-.895 1.791-.358 3.941 1.255 5.016l10.928 6.271"
          fill="#D6DCE8"
        />
        <path
          d="M44.636 26.76L73.84 57.037a2.77 2.77 0 01-.179 3.763L43.92 88.749a2.77 2.77 0 01-3.763-.18L3.251 49.334a2.77 2.77 0 01.179-3.763l21.499-20.245 19.707 1.434z"
          fill="#fff"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M24.929 25.145l8.062 8.421c1.075 1.075 3.046 1.075 4.3 0l7.345-6.987"
          fill="#D6DCE8"
        />
        <path
          d="M120.242 74.414l-11.287 40.31c-.358 1.255-1.792 2.15-3.225 1.613l-39.236-11.466c-1.254-.359-2.15-1.792-1.612-3.225L80.11 49.869c.359-1.254 1.792-2.15 3.225-1.612l28.486 8.24 8.421 17.917z"
          fill="#fff"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M98.749 78.943L79.77 73.691c-.441-.122-.599-1.024-.342-1.954.258-.93.857-1.622 1.298-1.5l18.978 5.253c.442.122.6 1.023.342 1.953-.257.93-.856 1.622-1.297 1.5zM96.36 87.58L77.38 82.33c-.44-.122-.599-1.024-.341-1.954.257-.93.856-1.622 1.297-1.5l18.979 5.252c.441.123.599 1.024.342 1.954-.258.93-.857 1.622-1.298 1.5zM182.931 42.347L161.343 30.2c-.502-.282-.422-1.431.173-2.489.595-1.057 1.535-1.722 2.037-1.44l21.588 12.148c.502.282.422 1.43-.173 2.488s-1.535 1.722-2.037 1.44zM177.404 52.166l-21.587-12.147c-.502-.282-.422-1.431.173-2.489.595-1.057 1.535-1.722 2.037-1.44l21.587 12.148c.503.282.423 1.43-.172 2.488s-1.536 1.722-2.038 1.44zM35.128 42.646l-15.033 13.81c-.35.321-1.23-.035-1.906-.771-.677-.737-.957-1.643-.607-1.965l15.033-13.81c.35-.32 1.23.036 1.906.772.676.736.957 1.643.607 1.964zM41.41 49.483l-15.033 13.81c-.35.322-1.23-.035-1.906-.771-.676-.736-.956-1.643-.607-1.964l15.033-13.81c.35-.321 1.23.035 1.906.771.677.737.957 1.643.607 1.965z"
          fill="#D6DCE8"
        />
        <path
          opacity={0.1}
          d="M170.764 87.492v64.318c0 3.942-3.225 7.167-7.166 7.167H61.657c-3.942 0-7.167-3.225-7.167-7.167v-49.627h41.744c4.121 0 8.242-1.433 11.287-4.12l11.287-9.317c3.225-2.508 7.167-4.12 11.287-4.12h40.132c.358.895.537 1.791.537 2.866z"
          fill="#AAB3C5"
        />
        <path
          d="M111.821 56.676l-3.404 11.287c-.358 1.433.537 3.225 1.971 3.762l9.853 3.046"
          fill="#D6DCE8"
        />
        <path
          d="M212.15 143.208l-36.907 20.066c-1.254.717-2.866.179-3.404-1.075l-18.632-36.011c-.538-1.254-.179-2.866 1.075-3.404l48.014-25.44c1.254-.717 2.867-.18 3.404 1.075l13.437 26.157-6.987 18.632z"
          fill="#fff"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M198.043 132.119l-11.731-18.4c-.273-.428.198-1.244 1.019-1.768.822-.524 1.76-.606 2.033-.178l11.732 18.4c.272.428-.198 1.244-1.02 1.768-.822.524-1.76.606-2.033.178zM190.413 136.985l-11.731-18.401c-.273-.428.198-1.244 1.019-1.768.822-.524 1.76-.606 2.033-.178l11.732 18.401c.273.428-.198 1.244-1.02 1.767-.821.524-1.76.607-2.033.179zM219.137 124.76l-10.391 5.375c-1.254.716-1.971 2.687-1.254 4.12l4.658 9.138"
          fill="#D6DCE8"
        />
        <path
          d="M172.734 121.532v31.711c0 4.121-3.404 7.346-7.345 7.346H60.581c-4.12 0-7.346-3.404-7.346-7.346v-34.219"
          stroke="#1676EE"
          strokeWidth={5.086}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M168.614 101.286h-35.832c-3.404 0-6.808 1.254-9.495 3.404l-9.496 7.703c-2.687 2.15-6.091 3.404-9.495 3.404H63.447c-4.12 0-7.524 3.225-7.524 7.346 0 .358 0 .717.179 1.075l7.346 39.236c.537 3.762 3.762 6.449 7.524 6.449h87.071c3.763 0 6.808-2.687 7.525-6.27l10.391-53.748c.538-3.941-1.971-7.883-6.27-8.42-.359-.179-.717-.179-1.075-.179z"
          fill="#fff"
        />
        <path
          d="M178.647 94.121h-42.998c-4.12 0-8.241 1.433-11.287 4.12l-11.287 9.138c-3.225 2.687-7.166 4.12-11.287 4.12h-48.91c-4.837 0-8.958 3.942-8.958 8.958 0 .359 0 .896.18 1.254l8.957 47.477c.717 4.479 4.479 7.883 8.958 7.883h103.912c4.479 0 8.241-3.224 8.958-7.524l12.362-65.035c.717-4.837-2.329-9.495-7.346-10.212-.358-.179-.895-.179-1.254-.179z"
          fill="#fff"
          stroke="#D6DCE8"
          strokeWidth={3.391}
          strokeMiterlimit={10}
        />
        <path
          d="M99.828 140.618a5.86 5.86 0 005.856-5.862 5.86 5.86 0 00-5.856-5.862 5.86 5.86 0 00-5.857 5.862 5.86 5.86 0 005.856 5.862zM133.016 140.618a5.86 5.86 0 005.857-5.862 5.86 5.86 0 00-5.857-5.862 5.86 5.86 0 00-5.857 5.862 5.86 5.86 0 005.857 5.862zM109.106 151.894c.532 0 1.065.178 1.419.711 1.42 1.954 3.55 3.02 6.035 3.02 2.307 0 4.614-1.066 5.857-3.02.532-.888 1.597-1.066 2.484-.355.888.533 1.065 1.598.355 2.486-1.952 2.842-5.324 4.619-8.874 4.619-3.549 0-6.744-1.777-8.874-4.619-.532-.888-.355-1.953.355-2.486.533-.356.888-.356 1.243-.356z"
          fill="#AAB2C5"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_1739:6153">
          <path fill="#fff" transform="translate(.904)" d="M0 0h224.192v189.875H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default CreatingFilesIcon;
